import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { NumericFormat } from 'react-number-format';
import { agingEnums, FindLoad, formatNumberToFix, SaveParams } from 'utils';

const CLAIM_ACTION_TYPE = 'GET_PENDING_CLAIMS_TOTAL';

export const Aging = ({ aging, totals }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const pendingClaimsTotal = useSelector((state) => state.claim.pendingClaimsTotal);
    const loader = FindLoad(CLAIM_ACTION_TYPE);

    const handlePush = (path) => {
        const params = {
            ...info,
        };
        params.skip = 0;
        params.limit = 50;
        params.page = 1;
        delete params.clientFull;
        if (path === info?.agingType) {
            delete params.agingType;
        } else {
            params.agingType = path;
        }
        SaveParams(navigate, { ...params });
    };

    return (
        <div className="aging-section-box space-between">
            <div className="flex-align-center" style={{ gap: 12 }}>
                <button
                    style={
                        info?.agingType === agingEnums.current
                            ? { boxShadow: '0px 0px 0px 4px #D1FADF, 0px 1px 2px 0px rgba(16, 24, 40, 0.05)' }
                            : {}
                    }
                    className="green-zone"
                    onClick={() => handlePush(agingEnums.current)}>
                    <span>0-30 days: </span>
                    <NumericFormat
                        className="zone-amount"
                        value={aging?.currentAmount ? formatNumberToFix(aging?.currentAmount) : 0}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                    />
                    <div className="badge">{aging?.currentCount ? aging?.currentCount : 0}</div>
                </button>
                <button
                    style={
                        info?.agingType === agingEnums.due
                            ? { boxShadow: '0px 0px 0px 4px #FEF0C7, 0px 1px 2px 0px rgba(16, 24, 40, 0.05)' }
                            : {}
                    }
                    className="orange-zone"
                    onClick={() => handlePush(agingEnums.due)}>
                    <span>31-60 days:</span>
                    <NumericFormat
                        className="zone-amount"
                        value={aging?.dueAmount ? formatNumberToFix(aging?.dueAmount) : 0}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                    />
                    <div className="badge">{aging?.dueCount ? aging?.dueCount : 0}</div>
                </button>
                <button
                    style={
                        info?.agingType === agingEnums.pastDue
                            ? { boxShadow: '0px 0px 0px 4px #FEE4E2, 0px 1px 2px 0px rgba(16, 24, 40, 0.05)' }
                            : {}
                    }
                    className="red-zone"
                    onClick={() => handlePush(agingEnums.pastDue)}>
                    <span>61+ days:</span>
                    <NumericFormat
                        className="zone-amount"
                        value={aging?.pastDueAmount ? formatNumberToFix(aging?.pastDueAmount) : 0}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                    />
                    <div className="badge">{aging?.pastDueCount ? aging?.pastDueCount : 0}</div>
                </button>
            </div>

            <div className="flex-align-center" style={{ gap: 12 }}>
                {totals ? (
                    <>
                        <div className="billing-total-row">
                            <p className="billing-total-title">{'Total Amount'}</p>
                            <div className="billing-total-price-row">
                                <NumericFormat
                                    value={formatNumberToFix(totals?.totalAMT || 0)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                />
                            </div>
                        </div>
                        <div className="billing-total-row">
                            <p className="billing-total-title">{'Total Paid'}</p>
                            <div className="billing-total-price-row">
                                <NumericFormat
                                    value={formatNumberToFix(totals?.totalPaid || 0)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                />
                            </div>
                        </div>
                        <div className="billing-total-row">
                            <p className="billing-total-title">{'Total Adjustments'}</p>
                            <div className="billing-total-price-row">
                                <NumericFormat
                                    value={formatNumberToFix(totals?.totalAdjustments || 0)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                />
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="billing-total-row">
                            <p className="billing-total-title">{'Total Allowed Amount'}</p>
                            <div className="billing-total-price-row">
                                <NumericFormat
                                    value={pendingClaimsTotal?.allowedAmount ? formatNumberToFix(pendingClaimsTotal?.allowedAmount) : 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                />
                            </div>
                        </div>
                        <div className="billing-total-row">
                            <p className="billing-total-title">{'Total Billed Amount'}</p>
                            <div className="billing-total-price-row">
                                <NumericFormat
                                    value={pendingClaimsTotal?.billedAmount ? formatNumberToFix(pendingClaimsTotal?.billedAmount) : 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

